import { render, staticRenderFns } from "./DoubleDepositPromptModal.vue?vue&type=template&id=b599cf9e&"
import script from "./DoubleDepositPromptModal.vue?vue&type=script&lang=js&"
export * from "./DoubleDepositPromptModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports